import { Component, OnInit } from '@angular/core';
import { FuncionService } from '../../servicios/funcion.service';
import { environment } from '../../../environments/environment.prod';
import { Title } from '@angular/platform-browser';

@Component({
  	selector: 'app-ubicaciones',
  	templateUrl: './ubicaciones.component.html',
  	styleUrls: ['./ubicaciones.component.css']
})
export class UbicacionesComponent implements OnInit {

	listaSucursales:any[] = [];

  	constructor( 
      private newFuncionService:FuncionService,
      private newTitle: Title
    ){ }

  	ngOnInit(): void {
      this.newTitle.setTitle("Ubicaciones");
  		this.newFuncionService.listaSucursales().subscribe( (listaSucursales)=>{
  			if( listaSucursales.length > 0 ){
  				this.listaSucursales = listaSucursales;
  			}
  		})
  	}

}
